import { isUrl } from '@albacross/frontend-utils'

export const customerCreateValidator = (values: any) => {
  const errors: Record<string, string> = {}

  if (!values.name) {
    errors.name = 'Name is required'
  } else if (values.name.length < 3 || values.name.length > 250) {
    errors.name = 'Name must be between 3 and 250 characters'
  }

  if (!values.website) {
    errors.website = 'Website is required'
  } else if (!isUrl(values.website.toLowerCase())) {
    errors.website = 'Website is invalid'
  }

  if (!values.country) {
    errors.country = 'Country is required'
  }

  if (!values.plan) {
    errors.plan = 'Plan is required'
  }

  if (!values.paymentMethod) {
    errors.paymentMethod = 'Payment method is required'
  }

  if (!values.billingPeriod) {
    errors.billingPeriod = 'Billing period is required'
  }

  return errors
}
